export const URL_PATH = process.env.REACT_APP_SERVER_ADDR
export const RESOURCES_URL = process.env.REACT_APP_RESOURCES_ADDR

export const TIENDA_NUBE_APP_URL = process.env.REACT_APP_TIENDA_NUBE_APP

export const TOKEN_PATH = 'token'
export const API_URL_PATH = URL_PATH + 'BackOffice/api'

export const PASSWORD_PATH = '/password'
export const STATUS_PATH = '/status'
export const APPCONFIG_PATH = '/AppConfiguration'
export const SHOPIFY_PATH = '/shopify'
export const SHOPCONFIG_GET_PATH = '/shopconfiguration/get'
export const SHOPCONFIG_POST_PATH = '/shopconfiguration/post'
export const SHOPCONFIG_GET_NEW_CLIENT_SECRET_PATH =
    '/shopconfiguration/getNewClientSecret'
export const PRICE_PATH = '/price'
export const ORDERS_PATH = '/orders'
export const CONTACT_PATH = '/contact'
export const REGISTRATION_PATH = '/Account/AddShopUser'
export const SHOP_INFO_PATH = '/Account/GetShopInfo'
export const WAREHOUSE_INFO_PATH = '/Account/GetWarehouseInfo'
export const GETEULA_PATH = '/Account/GetEula'
export const ACCEPTEULA_PATH = '/Account/AcceptEula'
export const GET_ORDER_EVENTS = 'events'
export const SEND_SMS = 'sendsms'
export const GET_PDF_RECEIPT = 'GetOrderLabel'
export const GET_PDF_RECEIPTS = 'GetOrderLabels'
export const TIENDANUBE_AUTHORIZE_PATH = '/TiendaNube/Authorize'
export const TRACKING_PATH = '/tracking'
export const GET_LOCKERSIZES_BY_ORDERID = '/GetLockerSizesByOrderId'
export const GET_DOOR_SIZES = '/GetDoorSizes'
export const ORDER_CANCEL = '/orderCancel'
export const ORDER_LIST_CANCEL = '/orderListCancel'
export const ORDER_EXTEND = '/orderExtend'
export const ORDER_EXTENDINFO = '/orderExtendInfo'
export const ORDER_RETURN = '/orderReturn'
export const ORDER_READY = '/orderReady'
export const ORDER_READY_ALL = '/orderReadyAll'
export const ORDER_RESERVE = '/orderReserve'
export const ORDER_CREATE_RESERVE = '/createReserve'
export const WOOCOMMERCE_PATH = '/woocommerce'
export const GETORDERADDRESS_PATH = '/getOrderAddress'
export const UPDATEORDERADDRESS_PATH = '/updateOrderAddress'
export const ADD_ORDER_TO_GROUP_READY_FOR_COLLECT_PATH = '/AddOrderToGroupReadyForCollect'
export const REMOVE_ORDER_TO_GROUP_READY_FOR_COLLECT_PATH = '/RemoveOrderToGroupReadyForCollect'
export const GETCOUNTRIES_PATH = '/Country/GetCountries'
export const GETCOUNTRYSUBDIVISIONS_PATH = '/Country/GetCountrySubdivisions'

export const GETTAXINGCATEGORYLIST_PATH = '/Account/GetTaxingCategories'
export const GETSHOPTYPELIST_PATH = '/Account/GetShopTypes'
export const GETCUITINFO_PATH = '/Account/GetCuitInformation'
export const VALIDATENEWSHOPNAME_PATH = '/Account/validateNewShopName'

export const RESET_PASSWORD_PATH = '/Account/ResetPassword'
export const RESET_PASSWORD_ASSIGNMENT_PATH = '/Account/ResetPasswordAssignment'

export const GET_BILLING_INFORMATION_PATH = '/Billing/Get'
export const SET_BILLING_INFORMATION_PATH = '/Billing/Post'

export const GET_SHIPPINGRATES_PATH = '/ShippingRates'
export const CREATE_NEWORDER_PATH = '/Orders/Create'
export const DISPATCH_TO_LOCKER_PATH = '/Orders/Create'
export const CREATE_DISPATCHORDER_PATH = '/Orders/CreateDispatchOrder'

export const LOCKER_PATH = '/locker'

export const GET_SERVICE_AREA_CONFIG_PATH = '/ServiceAreaConfiguration'
export const SET_SERVICE_AREA_CONFIG_PATH = '/ServiceAreaConfiguration'

export const GET_MOVEMENTS_SUMMARY_PATH = '/BillingMovements/GetSummary'
export const GET_MOVEMENTS_EXCEL_PATH = '/BillingMovements/GetExcel'

export const ORDER_INSURE_DATA_PATH = '/OrdersInsurance/OrderInsuranceInfo'
export const ORDER_INSURE_PATH = '/OrdersInsurance'

export const ORDER_IMPORTER_GET_DOORSIZES_PATH = '/OrderImporter/GetDoorSizes'
export const ORDER_IMPORTER_GET_LOCKERS_PATH = '/OrderImporter/GetLockers'
export const ORDER_IMPORTER_CREATE_ORDERS_PATH = '/OrderImporter/CreateOrderList'
export const ORDER_DOOR_SIZE_UPDATE_PATH = '/Orders/doorSizeUpdate'

export const NEWS_GET_ALL_NEWS = '/news/GetAllNews'
export const NEWS_SET_AS_READ = '/news/SetNewsAsRead?newsId='
export const NEWS_SET_AS_VIEW = '/news/SetNewsAsView?newsId='

export const ORDER_GET_RECOVERY_LABEL = '/Orders/GetRecoveryLabel'
export const ORDER_GET_RECOVERY_BARCODE = '/Orders/GetRecoveryBarCode'
export const ORDER_GET_DELIVERY_RECEIPT_LABEL = '/orders/GetDeliveredOrderLabel'
export const CANCEL_PARCEL = '/Orders/CancelParcel'

export const UPDATE_CONTACT_TIME_PATH = '/UpdateContactTime'
export const GET_CONTACT_TIME_PATH = '/GetContactTime'